// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom'; // React Router の Link を使用
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faTwitter, faYoutube, faLine } from '@fortawesome/free-brands-svg-icons';
import { isMobile } from 'react-device-detect'; // デバイスタイプの検出

const PCFooter = () => {
  return (
    <footer className="bg-gray-800 text-white py-6"> {/* py-20 で高さを調整 */}
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap justify-between">
          {/* 既存のセクション */}
          <div className="mb-4">
            <h4 className="text-lg font-bold mb-2">本演奏会について</h4>
            <ul>
              <li><Link to="/detail" className="text-gray-400 hover:text-white">詳細情報</Link></li>
            </ul>
          </div>
          {/*<div className="mb-4">
            <h4 className="text-lg font-bold mb-2">運営陣/参加者</h4>
            <ul>
              <li><Link to="/team" className="text-gray-400 hover:text-white">運営陣</Link></li>
              <li><Link to="/participants" className="text-gray-400 hover:text-white">参加者</Link></li>
            </ul>
          </div>*/}
          <div className="mb-4">
            <h4 className="text-lg font-bold mb-2">スケジュール</h4>
            <ul>
              <li><Link to="/schedule" className="text-gray-400 hover:text-white">スケジュール詳細</Link></li>
            </ul>
          </div>
          <div className="mb-4">
            <h4 className="text-lg font-bold mb-2">申し込み</h4>
            <ul>
              <li><Link to="/apply" className="text-gray-400 hover:text-white">申し込みフォーム</Link></li>
            </ul>
          </div>
          {/*<div className="mb-4">
            <h4 className="text-lg font-bold mb-2">ギャラリー</h4>
            <ul>
              <li><Link to="/gallery/photos" className="text-gray-400 hover:text-white">写真</Link></li>
              <li><Link to="/gallery/videos" className="text-gray-400 hover:text-white">練習動画</Link></li>
            </ul>
          </div>*/}
          <div className="mb-4">
            <ul>
              <li><Link to="/" className="text-gray-400 hover:text-white">トップページ</Link></li>
            </ul>
          </div>
          {/* 新しく追加するセクション */}
        </div>
        <br></br><br></br>
        <div className="flex justify-center mt-3">
          <a href="https://www.instagram.com/anoen2025/?utm_source=ig_embed&ig_rid=e42f20b4-19c3-432a-93bd-d224e592bd6b" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white mx-7">
            <FontAwesomeIcon icon={faInstagram} size="2x" />
          </a>
          <a href="https://x.com/anoen2025?ref_src=twsrc%5Etfw%7Ctwcamp%5Eembeddedtimeline%7Ctwterm%5Escreen-name%3Aanoen2025%7Ctwcon%5Es1" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white mx-7">
            <FontAwesomeIcon icon={faTwitter} size="2x" />
          </a>
          <a href="https://www.youtube.com/@%E3%81%82%E3%81%AE%E6%BC%94" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white mx-7">
            <FontAwesomeIcon icon={faYoutube} size="2x" />
          </a>
          {/* <a href="https://line.me" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white mx-7">
            <FontAwesomeIcon icon={faLine} size="2x" />
          </a> */}
        </div>
        <div className="text-center mt-20">
          <p className="text-gray-400">Copyright © 2024 「あの演奏会をもう一度」運営 All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
}

const MobileFooter = () => {
  return (
    <footer className="bg-gray-800 text-white py-6"> {/* py-20 で高さを調整 */}
      <div className="container mx-auto px-4">
      <div className="flex flex-col items-center justify-center">
      {/* 既存のセクション */}
      <div className="mb-4 text-center">
        <ul>
          <li><Link to="/detail" className="text-gray-400 hover:text-white">詳細情報</Link></li>
        </ul>
      </div>
      <div className="mb-4 text-center">
        <ul>
          <li><Link to="/schedule" className="text-gray-400 hover:text-white">スケジュール詳細</Link></li>
        </ul>
      </div>
      <div className="mb-4 text-center">
        <ul>
          <li><Link to="/apply" className="text-gray-400 hover:text-white">申し込みフォーム</Link></li>
        </ul>
      </div>
      <div className="mb-4 text-center">
        <ul>
          <li><Link to="/" className="text-gray-400 hover:text-white">トップページ</Link></li>
        </ul>
      </div>
      {/* 新しく追加するセクション */}
    </div>
        <div className="flex justify-center mt-3">
          <a href="https://www.instagram.com/anoen2025/?utm_source=ig_embed&ig_rid=e42f20b4-19c3-432a-93bd-d224e592bd6b" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white mx-7">
            <FontAwesomeIcon icon={faInstagram} size="2x" />
          </a>
          <a href="https://x.com/anoen2025?ref_src=twsrc%5Etfw%7Ctwcamp%5Eembeddedtimeline%7Ctwterm%5Escreen-name%3Aanoen2025%7Ctwcon%5Es1" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white mx-7">
            <FontAwesomeIcon icon={faTwitter} size="2x" />
          </a>
          <a href="https://www.youtube.com/@%E3%81%82%E3%81%AE%E6%BC%94" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white mx-7">
            <FontAwesomeIcon icon={faYoutube} size="2x" />
          </a>
          {/* <a href="https://line.me" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white mx-7">
            <FontAwesomeIcon icon={faLine} size="2x" />
          </a> */}
        </div>
        <div className="text-center mt-10">
          <p className="text-gray-400">Copyright © 2024 「あの演奏会をもう一度」運営 All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
}

function Footer() {
  return isMobile ? <MobileFooter /> : <PCFooter />;
}


export default Footer;
